"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Export data
var _default = exports.default = {
  domain: '',
  learnMore: {
    logo: {
      alt: 'SAP Logo',
      src: '/sites/all/modules/custom_concur/concur_sap_banner/images/sap-logo.png'
    },
    text: 'Concur は SAPグループ会社です',
    learn: {
      href: '/sap',
      text: '詳細はこちら'
    },
    learnExtra: {
      text: '株式会社コンカーはサンブリッジとのジョイントベンチャーです',
      href: '/sunbridge',
      hrefText: '詳細はこちら＞'
    }
  },
  social: [{
    network: 'facebook',
    href: ''
  }, {
    network: 'twitter',
    href: ''
  }, {
    network: 'linkedin',
    href: ''
  }, {
    network: 'youtube',
    href: ''
  }],
  support: {
    links: [{
      text: 'サービス稼働状況',
      href: ''
    }, {
      text: '問い合わせ',
      href: '/contact'
    }, {
      text: '見積もり依頼',
      href: '/get-quote-form'
    }, {
      text: 'サポート',
      href: '/support'
    }],
    selector: '国/地域の選択',
    modelTitle: 'Select your location:'
  },
  copyright: {
    text: '© Copyright @{year} Concur Technologies, Inc. All rights reserved.',
    links: [{
      text: '個人情報保護方針',
      href: '/privacy-policy'
    }, {
      text: '利用規約',
      href: ''
    }]
  }
};